<template>
  <div class="vx-row">
    <div class="vx-col w-full sm:w-1/1 md:w-1/1 lg:w-1/1 xl:w-1/1 mb-base">
      <div class="carousel-example">

        <div v-swiper:mySwiper="swiperOption">
          <div class="swiper-wrapper">
            <div class="swiper-slide" :key="agreement.tracking_id" v-for="agreement in slides">
              <span v-html="agreement.description"/>
            </div>
          </div>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
  import { apollo } from '../../plugins/apollo';
  import AGREEMENTS from '../../graphql/agreements.gql';

  const defaultSwiperOptions = {
    slidesPerView: 3,
    centeredSlides: true,
    spaceBetween: 30,
    pagination: {
      el: '.swiper-pagination',
      type: 'fraction'
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    breakpoints: {
      1024: {
        slidesPerView: 3,
        spaceBetween: 40
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 30
      },
      640: {
        slidesPerView: 1,
        spaceBetween: 20
      }
    }
  }

  export default {
    name: "CarouselAgreementSelector",
    props: {
      id: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        agreements: [],
        slides: [],
        swiperOption: {
          ...defaultSwiperOptions,
          pagination: false,
          keyboard: {
            enabled: true,
            onlyInViewport: false,
          },
        }
      }
    },
    async created() {

      const date = (string) => string.slice(0, 10).split('-').reverse().join('-');

      const { data: { agreements } } = await apollo.query({
        query: AGREEMENTS
      });

      this.agreements = agreements;
      this.slides = agreements.map(a => {
        if (a.name) {
          return {
            tracking_id: a.tracking_id, description:
              `${a.name + ' ' + a.surname}<br>${a.phone}<br>${a.email}<br>${a.bank}<br>${date(a.created_at)}`
          };
        } else {
          return {
            tracking_id: a.tracking_id, description:
              `${a.email}<br>${a.bank}<br>${date(a.created_at)}`
          };
        }
      });
      this.addListener();
    },
    mounted() {
      console.log("swp", this.$swiper);
      console.log("myswp", this.mySwiper);

      this.mySwiper.slideTo(0, 0, this.addListener);
    },
    methods: {
      addListener() {

        if (this.mySwiper && this.agreements.length) {

          this.mySwiper.on('slideChange', (e) => {
            this.$router.push({
              name: 'single-agreement',
              params: { id: this.agreements[this.mySwiper.realIndex].tracking_id }
            }).catch(() => {
            })

          })

        }

      }
    }
  }
</script>

<style lang="scss" scoped>
  .swiper-container {
    ::v-deep .swiper-slide {
      text-align: center;
      font-size: 16px;
      font-weight: 700;
      background: linear-gradient(118deg, rgba(var(--vs-primary), 1), rgba(var(--vs-primary), 0.7));
      box-shadow: 0 0 10px 1px rgba(var(--vs-primary), 0.7);
      margin-bottom: 10px;
      margin-top: 10px;
      border-radius: 5px;
      color: aliceblue;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      min-height: 145px;

      .theme-dark & {
        background-color: #242a47;
      }
    }
  }
</style>
